
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { fetchContentItem } from "./fetchContentItem";

/**
 * Prefetches a small set of related content items for faster navigation
 */
export const usePrefetchRelated = (userId: string | undefined, currentId: string | undefined) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const prefetchRelatedItems = async () => {
      if (!userId) return;
      
      try {
        const { data } = await supabase
          .from('content_items')
          .select('id')
          .eq('user_id', userId)
          .limit(20);
          
        if (data) {
          data.forEach(item => {
            if (item.id !== currentId) {
              queryClient.prefetchQuery({
                queryKey: ["contentItem", item.id],
                queryFn: () => fetchContentItem(item.id, userId, queryClient)
              });
            }
          });
        }
      } catch (error) {
        console.error("[NAVIGATION DEBUG] Error prefetching content items:", error);
      }
    };
    
    prefetchRelatedItems();
  }, [currentId, userId, queryClient]);
};
